"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResponseSchema = exports.BodySchema = exports.method = exports.path = void 0;
exports.parseBody = parseBody;
exports.parseResponse = parseResponse;
const zod_1 = require("zod");
const common_1 = require("../../../../common");
/** относительно `${config.http.webUrl}` */
exports.path = 'billing/2/operations/buy-credits';
exports.method = common_1.HttpMethod.POST;
// #region Request
exports.BodySchema = zod_1.z.object({
  credits_amount: zod_1.z.coerce.number()
});
function parseBody(dto) {
  return exports.BodySchema.parse(dto);
}
// export const ParamsSchema = z.object({});
// export type Params = z.infer<typeof ParamsSchema>;
// export function parseParams(values: Params) {
//   return ParamsSchema.parse(values);
// }
// export const QuerySchema = z.object({});
// export type Query = z.infer<typeof QuerySchema>;
// export function parseQuery(values: Query) {
//   return QuerySchema.parse(values);
// }
// #endregion
// #region Response
exports.ResponseSchema = zod_1.z.object({
  data: zod_1.z.object({
    billing_processor: zod_1.z.string(),
    billing_order_id: zod_1.z.string(),
    billing_charge_id: zod_1.z.string()
  })
});
function parseResponse(dto) {
  return exports.ResponseSchema.parse(dto);
}
// #endregion
